import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FaTooltipWrapper } from 'Components/UI/Tooltip';
import { DefinedPensionPlans as SectionKey } from 'Consts/Questionnaire';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import CircleWithCount from 'Icons/CircleWithCount';
import NumberInput from '../Fields/NumberInput';
import BoolInput from '../Fields/BoolInput';
import CurrencyInput from '../Fields/CurrencyInput';
import TextareaInput from '../Fields/TextareaInput';
import Section from '../Section';
import FieldList from '../Fields/FieldList';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import TextInput from '../Fields/TextInput';
import { advisorView } from '../../../../Context/ViewContext';

class DefinedPensionPlanList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      definedPensionPlanAccountOwner: '',
      definedPensionPlanFinancialInstitution: '',
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  render() {
    const {
      definedPensionPlanAccountOwner,
      definedPensionPlanFinancialInstitution,
    } = this.state;
    const {
      props: { id, children: removeButton, expanded },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        removeButton={removeButton}
        title={
          definedPensionPlanAccountOwner
            ? `${definedPensionPlanAccountOwner} - ${definedPensionPlanFinancialInstitution}`
            : 'New plan'
        }
        firstElementFocusable
        expanded={expanded}
      >
        <TextInput
          placeholder="Financial Institution"
          name={`definedPensionPlanFinancialInstitution.${id}`}
          answerKey="definedPensionPlanFinancialInstitution"
          onChange={(name, value) => this.onChange('definedPensionPlanFinancialInstitution', value)
          }
        />
        <TextInput
          placeholder="Account owner"
          name={`definedPensionPlanAccountOwner.${id}`}
          answerKey="definedPensionPlanAccountOwner"
          onChange={(name, value) => this.onChange('definedPensionPlanAccountOwner', value)
          }
        />
        <FaTooltipWrapper title="typically % of pay">
          <CurrencyInput
            placeholder="Annual employee contributions"
            name={`definedPensionPlanAnnualEmployeeContributions.${id}`}
            answerKey="definedPensionPlanAnnualEmployeeContributions"
          />
        </FaTooltipWrapper>
        <CurrencyInput
          placeholder="Annual employer contributions"
          name={`definedPensionPlanAnnualEmployerContributions.${id}`}
          answerKey="definedPensionPlanAnnualEmployerContributions"
        />
        <BoolInput
          label="Is there a lump sum option?"
          name={`definedPensionPlanLumpSum.${id}`}
          answerKey="definedPensionPlanLumpSum"
          checkedChildren={
            <CurrencyInput
              placeholder="Balance"
              name={`definedPensionPlanBalance.${id}`}
              answerKey="definedPensionPlanBalance"
            />
          }
        />
        <TextareaInput
          requiredView={advisorView}
          placeholder="Estimated benefits"
          name={`definedPensionPlanEstimatedBenefits.${id}`}
          answerKey="definedPensionPlanEstimatedBenefits"
        />
        <FaTooltipWrapper title="0% to 100% based on years with employer">
          <NumberInput
            placeholder="Vesting"
            name={`definedPensionPlanVesting.${id}`}
            answerKey="definedPensionPlanVesting"
            decimalScale={2}
            min={0}
            max={100}
            suffix="%"
          />
        </FaTooltipWrapper>
        <BoolInput
          label="Beneficiary elections"
          name={`definedPensionPlanBeneficiaryElections.${id}`}
          answerKey="definedPensionPlanBeneficiaryElections"
          checkedChildren={
            <Fragment>
              <TextInput
                placeholder="Beneficiary (primary)"
                name={`definedPensionPlanBeneficiaryPrimary.${id}`}
                answerKey="definedPensionPlanBeneficiaryPrimary"
              />
              <TextInput
                placeholder="Beneficiary (contingent)"
                name={`definedPensionPlanBeneficiaryContingent.${id}`}
                answerKey="definedPensionPlanBeneficiaryContingent"
              />
            </Fragment>
          }
        />
      </LabeledVerticalExpander>
    );
  }
}

DefinedPensionPlanList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
};

DefinedPensionPlanList.defaultProps = {
  expanded: false,
};

const DefinedPensionPlans = () => {
  const [count, setCount] = React.useState(0);

  return (
    <Section
      transitionSpeed={0.25}
      height={400}
      title="Pension Plans / Defined benefit plans"
      expanded={QueryVal(section) === SectionKey}
      sectionKey={SectionKey}
      CountComponent={<CircleWithCount count={count} className="expander-header-count expander-header-left" />}
    >
      <FieldList
        onCountUpdate={setCount}
        addLabel="Add a plan"
        label="Plan - defined pension"
        keyPrefix="definedPensionPlans"
        Of={DefinedPensionPlanList}
      />
    </Section>
  );
};

export default DefinedPensionPlans;
